const READINESS_TIMEOUT = 15000

export async function ensureOfflineServiceWorker({ serviceWorker = globalThis.navigator?.serviceWorker, signal, timeout = READINESS_TIMEOUT } = {}) {
  signal?.throwIfAborted()
  if (!serviceWorker) throw Object.assign(new Error("Service Workers are unavailable"), { code: "unsupported" })
  if (serviceWorker.controller) return

  await new Promise((resolve, reject) => {
    let settled = false
    const finish = (error) => {
      if (settled) return
      settled = true
      clearTimeout(timer)
      serviceWorker.removeEventListener("controllerchange", controlled)
      signal?.removeEventListener("abort", aborted)
      if (error) reject(error)
      else resolve()
    }
    const controlled = () => {
      if (serviceWorker.controller) finish()
    }
    const aborted = () => finish(signal.reason)
    // Installation failure can leave serviceWorker.ready pending indefinitely.
    const timer = setTimeout(() => finish(new Error("Offline Service Worker did not take control")), timeout)
    serviceWorker.addEventListener("controllerchange", controlled)
    signal?.addEventListener("abort", aborted, { once: true })

    Promise.resolve().then(() => {
      if (!settled) return serviceWorker.register("/service-worker.js", { scope: "/" })
    })
      .then(() => serviceWorker.ready)
      .then((registration) => {
        if (settled) return
        controlled()
        // Activation can miss a document still navigating. Ask again now that
        // this page is executing, and wait for actual control before readiness.
        if (!settled) registration.active.postMessage({ type: "CLAIM_CLIENTS" })
      }).catch(finish)
    controlled()
  })
}
